import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function GraphicStandsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } >
                { ({ match, history }) => <Pages.GraphicStand match={ match } history={ history } /> }
            </Route>

            <Route path={ `${ path }/create` }>
                <Pages.GraphicStand />
            </Route>
        </Switch>
    );
}


